import * as styles from "./Switch.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Switch as BaseSwitch } from "@base-ui/react/switch";
import { useControlContext } from "@frontend/contexts";

import type { SwitchProps } from "./Switch.types";

export function Switch({
  size,
  label,
  truncate,
  className,
  ...props
}: SwitchProps): JSX.Element {
  const inherited = useControlContext();
  const resolvedSize = size ?? inherited.size;

  return (
    <label className={clsx(styles.label, truncate && styles.labelTruncated)}>
      <BaseSwitch.Root
        data-slot="switch"
        className={clsx(styles.track({ size: resolvedSize }), className)}
        {...props}
      >
        <BaseSwitch.Thumb
          className={clsx(
            styles.thumbTrack({ size: resolvedSize }),
            styles.thumb,
          )}
        />
      </BaseSwitch.Root>
      {label ? (
        <span
          data-slot="switch-label"
          className={truncate ? styles.labelText : undefined}
          title={truncate ? label : undefined}
        >
          {label}
        </span>
      ) : null}
    </label>
  );
}
